import { PulseLoader } from "react-spinners";
import "./LoaderPulse.css";

const LoaderPulse = ({ text }) => {
  return (
    <div className="loader">
      <PulseLoader color="#1C1C1C" size={15} title="okk" />
      {text && <h2 className="loader-text">{text}</h2>}
    </div>
  );
};

export default LoaderPulse;
